import { useFilters } from 'components/Dashboard/Filters/FiltersContext';
import MoreFiltersButton from 'components/Dashboard/Filters/ui/MoreFiltersButton';
import useDetectActiveFilters from 'components/Dashboard/SubNav/useDetectActiveFilters';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';
import SubnavSearchBar from 'components/Dashboard/Influence/InfluenceCrmSubNav/components/SubnavSearchBar';
import React, { useRef, useState } from 'react';

const NotesPageSubNav = ({ notesAuthor, setNotesAuthor }) => {
  const { clearFilters } = useFilters();
  const { detectActiveFilters } = useDetectActiveFilters();
  const hasActiveFilters = detectActiveFilters();

  const isMobile = useIsMobile();
  const [showBox, setShowBox] = useState(false);

  const actionsElement = useRef(null);
  const hideActions = () => {
    setShowBox(false);
  };
  useOutsideElement(actionsElement, hideActions);

  return (
    <>
      <div className={`bg-white monitor-items-bar flex-centered`} style={{ minHeight: '59px' }}>
        <div className='mx-auto main-content-wrapper flex-centered justify-content-between resize-elements-container'>
          <div className='side-left-element pl-lg-5 pl-4 d-none d-lg-block '>
            <div className='position-relative mr-3'>
              <p className={`mb-0 title-h4 nowrap-item font-weight-bold`}>Notes</p>
            </div>
          </div>
          <div className='main-content flex-centered position-relative filters-general-container justify-content-between pr-xl-5 px-md-4 px-3'>
            <div className='flex-grow-1 flex-centered justify-content-between'>
              <div className='flex-centered position-relative' ref={actionsElement}>
                <h3
                  className={`main-title mb-0 hidden-lines hidden-one-line current-folder-name ${
                    isMobile ? `dropdown-item-element pointer dropdown-item-element-main-title` : ''
                  } ${showBox ? 'open' : ''}`}
                  onClick={() => {
                    if (isMobile) {
                      setShowBox(!showBox);
                    }
                  }}
                >
                  {notesAuthor === 'my-own' ? 'My notes' : "My team's notes"}
                </h3>

                {showBox && (
                  <div className='login-navbar py-2 main-title-items mobile-list-sidenav-folders'>
                    <div className='scroll-container hover-container search-bar-lists'>
                      <ul className='policy-list px-0 mb-0 hover-content'>
                        <li
                          className={`px-2 pl-3 pl-lg-5 sidebar-item pointer d-flex align-items-center ${
                            notesAuthor === 'my-own' ? 'active' : ''
                          }`}
                          onClick={() => {
                            setNotesAuthor('my-own');
                            setShowBox(false);
                          }}
                        >
                          <span className='icon-edit-pencil pr-2 d-inline-block'></span>
                          <p
                            className='mb-0 side-nav-saved-title hidden-lines hidden-one-line'
                            data-tooltip-content={name.length > 26 ? name : ''}
                            data-tooltip-id={'general-tooltip'}
                          >
                            My notes
                          </p>
                        </li>
                        <li
                          className={`px-2 pl-3 pl-lg-5 sidebar-item pointer d-flex align-items-center ${
                            notesAuthor === 'my-teams' ? 'active' : ''
                          }`}
                          onClick={() => {
                            setNotesAuthor('my-teams');
                            setShowBox(false);
                          }}
                        >
                          <span className='icon-edit-pencil pr-2 d-inline-block'></span>
                          <p
                            className='mb-0 side-nav-saved-title hidden-lines hidden-one-line'
                            data-tooltip-content={name.length > 26 ? name : ''}
                            data-tooltip-id={'general-tooltip'}
                          >
                            My team's notes
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              {!isMobile && <SubnavSearchBar className='mr-0' placeholder='Search notes' live />}
            </div>
            {!isMobile && (
              <div className='ml-4 flex-centered justify-content-end gap-15' style={{ width: '250px' }}>
                <button
                  className={`general-button action-button py-1 px-3 action-delete-button rounded-pill`}
                  style={{ visibility: hasActiveFilters ? 'visible' : 'hidden' }}
                  onClick={() => {
                    clearFilters();
                  }}
                >
                  Clear filters
                </button>
              </div>
            )}
            {isMobile && (
              <div className='d-flex gap-15 align-items-baseline'>
                {hasActiveFilters && (
                  <button
                    className={`general-button action-button py-1 px-3 action-delete-button rounded-pill`}
                    onClick={() => {
                      clearFilters();
                    }}
                  >
                    Clear filters
                  </button>
                )}
                <MoreFiltersButton section={'Notes'} />
              </div>
            )}
          </div>
        </div>
      </div>
      {isMobile && (
        <div className='w-100 px-3 bg-main-white border-bottom pb-3'>
          <div className='w-100 pt-3 d-block'>
            <SubnavSearchBar placeholder='Search notes' live />
          </div>
        </div>
      )}
    </>
  );
};

export default NotesPageSubNav;
